var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasurementVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 498.4 460.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498.38,10.01c0-1.03-.16-2.07-.49-3.09-.2-.61-.55-1.12-.85-1.66-.13-.23-.2-.45-.34-.66-.89-1.36-2.08-2.42-3.48-3.21-.14-.08-.19-.24-.33-.31-.14-.07-.29-.02-.43-.09-1.28-.58-2.64-1-4.11-1H149.94c-2.13,0-4.21,.68-5.94,1.94L4.11,104.38c-.25,.18-.41,.44-.64,.65-.33,.29-.62,.59-.91,.92-.53,.61-.96,1.26-1.33,1.97-.18,.35-.38,.67-.53,1.05-.43,1.12-.71,2.3-.71,3.51V450.89c0,5.55,4.5,10.05,10.05,10.05H348.45c1.21,0,2.39-.28,3.54-.72,.39-.15,.72-.36,1.08-.55,.44-.23,.91-.38,1.32-.67l139.89-102.44c2.58-1.89,4.11-4.9,4.11-8.11V10.05s-.01-.02-.01-.04ZM153.23,20.1H457.61l-110.94,81.24-1.5,1.1H40.78L153.23,20.1ZM20.1,122.53H338.4V440.84H20.1V122.53ZM358.5,431.08V117.58l28.31-20.73L478.29,29.86V343.36l-119.79,87.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementVolume);
export default __webpack_public_path__ + "static/media/measurementVolume.a5fee840c798bb05e99274d1400170b7.svg";
export { ForwardRef as ReactComponent };